<template>
  <v-flex>
    <v-container class="mx-auto">
      <v-row class="ma-6">
        <v-col class="col-xl-4 col-md-6 col-12" v-for="component in roleComponents" :key="component">
          <component :is="component" />
        </v-col>
      </v-row>
    </v-container>
    <NoticePopup v-if="memberId" />
  </v-flex>
</template>
<script>

import {mapGetters} from "vuex";
import MonthlyLoanPerformance from "@/pages/Main/components/MainPage/MonthlyLoanPerformance.vue";
import MemberStatus from "@/pages/Main/components/MainPage/MemberStatus.vue";
import NoticeCarousels from "@/pages/Main/components/MainPage/NoticeCarousels.vue";
import CertificatesCollection from "@/pages/Main/components/MainPage/CertificatesCollection.vue";
import LecturesCollection from "@/pages/Main/components/MainPage/LecturesCollection.vue";
import LoanAndBizRouting from "@/pages/Main/components/MainPage/LoanAndBizRouting.vue";
import TopRanking from "@/pages/Main/components/MainPage/TopRanking.vue";
import NoticePopup from "@/pages/Main/popup/MainPage/NoticePopup.vue";


export default {
  name: "MainPage",
  components: {
    NoticePopup,
    MonthlyLoanPerformance,
    MemberStatus,
    NoticeCarousels,
    CertificatesCollection,
    LecturesCollection,
    LoanAndBizRouting,
    TopRanking
  },
  data() {
    return {
      // adminCardTitleList: ["MonthlyLoanPerformance", "MemberStatus", "NoticeCarousels", "CertificatesCollection", "LecturesCollection", "LoanAndBizRouting"],
      // managerCardTitleList: ["MonthlyLoanPerformance", "MemberStatus", "NoticeCarousels", "CertificatesCollection", "LecturesCollection", "LoanAndBizRouting"],
      // userCardTitleList: ["MonthlyLoanPerformance", "LoanAndBizRouting", "NoticeCarousels", "CertificatesCollection", "LecturesCollection"],
      adminCardTitleList: ["MonthlyLoanPerformance", "MemberStatus", "TopRanking", "NoticeCarousels", "CertificatesCollection", "LecturesCollection", "LoanAndBizRouting"],
      managerCardTitleList: ["MonthlyLoanPerformance", "MemberStatus", "TopRanking", "NoticeCarousels", "CertificatesCollection", "LecturesCollection", "LoanAndBizRouting"],
      userCardTitleList: ["MonthlyLoanPerformance", "LoanAndBizRouting", "TopRanking", "NoticeCarousels", "CertificatesCollection", "LecturesCollection"],
      cardsList: [],
      isShowPopup: false,
      popupList: []
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      memberId: "memberId"
    }),
    roleComponents() {
      switch (this.memberRole) {
        case "ADMIN":
          return this.adminCardTitleList
        case "MANAGER":
          return this.managerCardTitleList
        case "USER":
          return this.userCardTitleList
        default:
          return [];
      }
    }
  }
}
</script>
